// types
import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
	openItem: [],
	defaultId: 'dashboard',
	openComponent: 'buttons',
	drawerOpen: true,
	componentDrawerOpen: true,
	menuItems: [],
	menuNotification: {},
	selectedModule: 'GLOBAL',
	selectedModuleName: 'Global',
	moduleMenuMap: null,
};

// ==============================|| SLICE - MENU ||============================== //

const menuSlice = createSlice({
	name: 'menu',
	initialState,
	reducers: {
		activeItem(state, action) {
			state.openItem = action.payload.openItem;
		},
		activeComponent(state, action) {
			state.openComponent = action.payload.openComponent;
		},
		openDrawer(state, action) {
			state.drawerOpen = action.payload.drawerOpen;
		},
		openComponentDrawer(state, action) {
			state.componentDrawerOpen = action.payload.componentDrawerOpen;
		},
		getRoleMenu(state, action) {
			if (action?.payload.type === 'initial') {
				state.menuItems = action.payload.menuItems;
				state.menuNotification = action.payload.menuNotification;
			} else if (action?.payload.type === 'updateCount') {
				state.menuNotification = action.payload.menuNotification;
			}
		},
		updateMenuItemsCount(state, action) {
			state.menuNotification = {
				...state.menuNotification,
				[action.payload.page]: action.payload.data,
			};
		},
		setSelectedModule(state, action) {
			const payload = action.payload;
			const isObjectPayload = payload !== null && typeof payload === 'object';
			const moduleCode = isObjectPayload ? payload.moduleCode ?? payload.name ?? 'GLOBAL' : payload ?? 'GLOBAL';
			const moduleName = isObjectPayload
				? payload.moduleName ?? payload.title ?? (moduleCode === 'GLOBAL' ? 'Global' : moduleCode)
				: moduleCode === 'GLOBAL'
					? 'Global'
					: moduleCode;

			state.selectedModule = moduleCode;
			state.selectedModuleName = moduleName;
			const moduleEntry = state.moduleMenuMap && moduleCode ? state.moduleMenuMap[moduleCode] : null;
			state.menuItems = Array.isArray(moduleEntry?.menuId) ? moduleEntry.menuId : [];
			state.menuNotification = {};
		},
		setModuleMenuMap(state, action) {
			state.moduleMenuMap = action.payload;
		},
		resetMenu(state) {
			state.openItem = [];
			state.defaultId = 'dashboard';
			state.openComponent = 'buttons';
			state.drawerOpen = false;
			state.componentDrawerOpen = true;
			state.menuItems = [];
			state.moduleItems = [];
			state.menuNotification = {};
			state.selectedModule = 'GLOBAL';
			state.selectedModuleName = 'Global';
			state.moduleMenuMap = null;
		},
	},
});

export default menuSlice.reducer;

export const {
	activeItem,
	activeComponent,
	openDrawer,
	openComponentDrawer,
	getRoleMenu,
	resetMenu,
	updateMenuItemsCount,
	setSelectedModule,
	setModuleMenuMap,
} = menuSlice.actions;
